/* eslint-disable quote-props */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/useElement'
import cookie from 'js-cookie'
import VueI18n from 'vue-i18n'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import md5 from 'js-md5'
import MyUtil from './utils/utils'
import EventBus from './utils/EventBus'
import VideoPlayer from 'vue-video-player'
// 引入css

import '@/assets/style/index.min.css'
import '@/assets/icon/iconfont.css'
import '@/utils/sxpcwlkj.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import 'animate.css'
import 'hover.css'

// 阻止 vue 在启动时生成生产提示
Vue.config.productionTip = false

Vue.prototype.cookie = cookie

Vue.use(EventBus);

Vue.use(ElementUi)

Vue.use(VueI18n)

Vue.use(VueAwesomeSwiper)
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

Vue.prototype.$axios = axios

// 这几个路由路径不验证
const white = ['/login', '/register', '/change', '/myLogin', '/myTxt']
import { webSiteConfig } from '@/api';

/**
 * 路由前置过滤,处理登录拦截
 */
router.beforeEach((to, from, next) => {
    // 动态设置标题
    const baseTitle = process.env.VUE_APP_TITLE || '默认标题';
    document.title = to.meta.title ? `${to.meta.title} | ${baseTitle}` : baseTitle;
    store.commit('setNavActive', to.name)
    if (!white.includes(to.path) || true) {
        // console.log(store.state.userState)
        // console.log(cookie.get('userToken'))
        // console.log(store.state.hasLogin)
        // if (cookie.get('userToken') || store.state.hasLogin) {
        //     console.log(1)
        //     next()
        // } else {
        //     if (from.path !== '/myLogin') {
        //         console.log(2)
        //         next('/myLogin')
        //     }
        // }

        // 初始化数据
        if (store.state.websiteInfo == null) {
            webSiteConfig({}).then(res => {
                store.commit('setWebsiteInfo', res.data)
                document.title = res.data.websiteTitle
                // 设置关键词 - 需操作<meta name="keywords">标签
                const keywordsMeta = document.querySelector('meta[name="keywords"]') || document.createElement('meta');
                keywordsMeta.name = "keywords";
                keywordsMeta.content = res.data.websiteKeywords; // 或用独立的关键词字段更合理
                document.head.appendChild(keywordsMeta);
                // 设置描述 - 需操作<meta name="description">标签
                const descriptionMeta = document.querySelector('meta[name="description"]') || document.createElement('meta');
                descriptionMeta.name = "description";
                descriptionMeta.content = res.data.websiteDescription;
                document.head.appendChild(descriptionMeta);
            })
        } else {
            document.title = store.state.websiteInfo.websiteTitle
            // 设置关键词 - 需操作<meta name="keywords">标签
            const keywordsMeta = document.querySelector('meta[name="keywords"]') || document.createElement('meta');
            keywordsMeta.name = "keywords";
            keywordsMeta.content = store.state.websiteInfo.websiteKeywords; // 或用独立的关键词字段更合理
            document.head.appendChild(keywordsMeta);
            // 设置描述 - 需操作<meta name="description">标签
            const descriptionMeta = document.querySelector('meta[name="description"]') || document.createElement('meta');
            descriptionMeta.name = "description";
            descriptionMeta.content = store.state.websiteInfo.websiteDescription;
            document.head.appendChild(descriptionMeta);
        }

        next()
    }

})

/**
 * 设置cookie
 * @param name => token名称
 * @param data => token数据
 * @param expires => 过期时间 6：6天后失效
 */
Vue.prototype.set_cookie = (name, data, expires) => {
    cookie.set(name, data, {
        expires: expires
    })
}
/**
 * 获取cookie
 */
Vue.prototype.get_cookie = (name) => {
    return cookie.get(name)
}
/**
 * 删除cookie
 */
Vue.prototype.remove_cookie = (name) => {
    cookie.remove(name)
}
/**
 * 数据md5加密
 * @param data => 传入需要加密的数据
 */
Vue.prototype.encryption = (data) => {
    return md5(data)
}

const messages = {
    'cn': require('@/assets/lang/cn.js'),
    'en': require('@/assets/lang/en.js')
}

const i18n = new VueI18n({
    locale: cookie.get('lang') || 'cn',
    messages
})

/**
 * 全局挂载工具类
 */
Vue.prototype.$MyUtil = MyUtil

Vue.prototype.$common = MyUtil;
new Vue({
    router,
    i18n,
    store,
    render: h => h(App)
}).$mount('#app')
